/**
 * Server-backed terrain config. Controls the height-field amplitude and the
 * biome/material type. Shared between the editor and the game at boot time.
 */

export type TerrainType = 'grass' | 'dirt' | 'sand' | 'rock';

export interface TerrainConfig {
  /** Base amplitude of the first fbm octave. Each octave halves; ~5 octaves. */
  amplitude: number;
  type: TerrainType;
}

export const TERRAIN_DEFAULTS: TerrainConfig = {
  amplitude: 0.5,
  type: 'grass',
};

const API_URL = '/api/terrain';
let cache: TerrainConfig = { ...TERRAIN_DEFAULTS };

export async function loadTerrainConfig(): Promise<TerrainConfig> {
  try {
    const res = await fetch(API_URL, { cache: 'no-cache' });
    if (res.ok) {
      const j = await res.json();
      if (j && typeof j === 'object') {
        cache = { ...TERRAIN_DEFAULTS, ...(j as Partial<TerrainConfig>) };
      }
    }
  } catch (err) {
    console.warn('loadTerrainConfig failed:', err);
  }
  return cache;
}

export function getTerrainConfig(): TerrainConfig {
  return cache;
}

export async function saveTerrainConfig(cfg: TerrainConfig): Promise<void> {
  cache = cfg;
  const res = await fetch(API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(cfg),
  });
  if (!res.ok) throw new Error(`POST /api/terrain → ${res.status}`);
}
